<template>
	<div class="editor">
		<div ref="toolbarRef" class="toolbar" style="display: none"></div>
		<div ref="textRef" class="text"></div>
	</div>
</template>
<script>
import E from 'wangeditor'
export default {
	name: "WangEditor",
	data() {
		return {
			editor: null,
		}
	},
	props: {
		introduce: {
			type: String,
			default: ""
		}
	},
	mounted() {
		this.initEditor()
		this.editor.txt.html(this.introduce)
	},
	watch: {
		// 深度监听introduce
		introduce: {
			handler(newVal) {
				this.$nextTick(() => {
					this.editor.txt.html(newVal)
				})
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		initEditor() {
			this.editor = new E(this.$refs.toolbarRef, this.$refs.textRef)
			this.editor.config.zIndex = 999
			// 取消自动 focus
			this.editor.config.focus = false
			this.editor.create()
			this.editor.disable();
		}
	}
}
</script>

<style scoped lang="css">
.editor {
	width: 100%;
	margin: auto;
	position: relative;
	flex: 1;
}
.text {
	background-color: #fff;
}
::v-deep .w-e-text-container  p {
	margin: 0;
}
::v-deep .w-e-text-container img {
	max-width: 100%;
	height: auto;
}
</style>